import { useGcsStore } from '../../../store/useGcsStore';
import { type AircraftId } from '../../../types/gcs/foreignAircraft';
import { ForeignAircraftMarker } from './markers/ForeignAircraftMarker';

interface SingleForeignAircraftMarkerProps {
  gcsId: string;
  aircraftId: AircraftId;
}

export const SingleForeignAircraftMarker = ({ gcsId, aircraftId }: SingleForeignAircraftMarkerProps) => {
  const aircraftDetails = useGcsStore((state) => {
    const gcsData = state.data.get(gcsId);
    return gcsData?.foreignAircraftDetailsMap.get(aircraftId);
  });

  const riskVolume = useGcsStore((state) => {
    const gcsData = state.data.get(gcsId);
    return gcsData?.foreignAircraftRiskVolumeMap.get(aircraftId)?.riskVolume;
  });

  if (!aircraftDetails) {
    return null;
  }

  return (
    <ForeignAircraftMarker
      aircraftId={aircraftId}
      longitude={aircraftDetails.location.lng}
      latitude={aircraftDetails.location.lat}
      altitude={aircraftDetails.location.alt}
      heading={aircraftDetails.heading}
      riskVolume={riskVolume}
    />
  );
};
